import { useEffect, useRef } from 'react'

type PageInfo = { hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }

export const usePageInfo = (pageInfo: PageInfo | undefined) => {
  const pageInfoRef = useRef<PageInfo>(null)

  useEffect(() => {
    if (!pageInfo) return

    pageInfoRef.current = pageInfo
  }, [pageInfo])

  return {

    pageInfo: pageInfoRef,
  }
}
